import { connect } from "react-redux";
import AddAmount from "./Amount";
import { bindActionCreators } from "redux";
import {addMoney} from "../../../services/redux/Wallet/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    listing : state.Wallet.listing,
    transaction : state.Wallet.transaction,
    addedMoney : state.Wallet.addedMoney,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        addMoney,
        documentUploadUrlPublic
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddAmount);